import { GetPortalsResponse } from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const getPortals = (): Promise<GetPortalsResponse> =>
  request({
    url: '/service/userv2service/GetPortals',
    body: {},
  }).then((r) => r.body);
